import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const datePickerTheme: ThemeOptions['components'] = {
  DsDatePicker: {
    styleOverrides: {
      input: {
        '*': {
          cursor: 'pointer',
        },

        '& .MuiFilledInput-root.MuiInputBase-formControl.DS-Input-readOnly': {
          backgroundColor: tokens.theme.bg.structural.surface,

          '&.Mui-focused': {
            borderColor: tokens.theme.border.selection.primary,
            boxShadow: `0px 0px 1px ${tokens.theme.border.selection.primary}`,
          },

          '& .MuiInputBase-input': {
            color: tokens.theme.fg.structural.primary,

            '&::placeholder': {
              color: tokens.theme.fg.structural.secondary,
              opacity: 'unset',
            },
            '&:focus::placeholder': {
              color: tokens.theme.fg.structural.secondary,
            },
          },
        },

        '&.DS-DatePickerInput-readOnly': {
          '*': {
            cursor: 'default',
          },

          '& .MuiFilledInput-root.MuiInputBase-formControl.DS-Input-readOnly': {
            backgroundColor: tokens.theme.readonly.bg,

            '&.Mui-focused': {
              boxShadow: 'none',
            },

            '& .MuiInputBase-input': {
              color: tokens.theme.readonly.fg,

              '&::placeholder': {
                color: tokens.theme.fg.structural.secondary,
                opacity: 'unset',
              },
              '&:focus::placeholder': {
                color: tokens.theme.fg.structural.secondary,
              },
            },
          },
        },
      },
    },
  },
};
